import React, { useEffect, useState } from 'react';
import { selectFilter, textFilter } from 'react-bootstrap-table2-filter';
import { VscNewFile, VscRefresh, VscSearch } from 'react-icons/vsc';
import { useDispatch, useSelector } from 'react-redux';
import AttenteRequete from '../../../../../hoc/AttenteRequete/AttenteRequete';
import { checkMot } from '../../../../../ressources/functionJS/checkMot';
import { getProjectIDTree } from '../../../../../ressources/functionJS/getProjectIDTree';
import { searchKeyInTree } from '../../../../../ressources/functionJS/searchKeyInTree';
import * as privilege from '../../../../../ressources/glossaires/glossaire_privileges';
import * as requestType from '../../../../../ressources/glossaires/glossaire_requetes';
import * as type_btn from '../../../../../ressources/glossaires/glossaire_type_de_bouton';
import * as glossaire_type_de_graphe from '../../../../../ressources/glossaires/glossaire_type_de_graphe';
import privet from '../../../../../ressources/Logo/close_p.png';
import publiq from '../../../../../ressources/Logo/open_p.png';
import * as actions from '../../../../../services/actions';
import Bouton from '../../../../UI/Bouton/Bouton';
import Tableau from '../../../../UI/tableau/Tableau';
import S from './TableauGraphe.module.scss';

const TableauGraphe = ({ creer, projetSelectione, siLaListeAUneValeur }) => {
  const dispatch = useDispatch();

  // Redux state
  const listeGraphes = useSelector((state) => state.graphe.graphs_list);
  const filtre_projects_list_id = useSelector(
    (state) => state.authentifie.filtre_projects_list_id
  );
  const project_id_url = useSelector(
    (state) => state.interfaceClient.project_id_url
  );
  const arborescence_projets = useSelector(
    (state) => state.interfaceClient.arborescence_projets
  );
  const interfaceAdmin = useSelector(
    (state) => state.authentifie.interfaceAdmin
  );
  const projects_list = useSelector((state) => state.authentifie.projects_list);

  // Split state into multiple useState hooks
  const [iconeCreer] = useState(<VscNewFile size={15} />);

  const [selectRow] = useState({
    mode: 'radio',
    clickToSelect: true,
    hideSelectAll: true,
    hideSelectColumn: true,
    style: () => ({
      background: '#eeb214',
      color: 'black',
    }),
    onSelect: (row) => projetSelectione(row),
  });

  const [columns, setColumns] = useState([
    {
      dataField: 'private',
      text: checkMot('propriete') + ' ',
      sort: true,
      headerAlign: 'center',
      align: 'center',
      style: {
        width: '150px',
      },
      formatter: (cell) => {
        switch (parseInt(cell)) {
          case 1:
            return <img alt="prive" title="prive" src={privet} className="" />;

          case 0:
            return (
              <img alt="public" title="public" src={publiq} className="" />
            );
          default:
            return checkMot(cell);
        }
      },
      filter: selectFilter({
        options: {
          1: checkMot('prive'),
          0: checkMot('public'),
        },
        placeholder: checkMot('selectionner'),
      }),
    },
    {
      dataField: 'graph_id',
      text: [
        checkMot('id'),
        <Bouton
          key={'graph_id_header_search'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('graph_id', checkMot('graph_id'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      hidden: interfaceAdmin,
      headerAlign: 'left',
      align: 'left',
    },
    {
      dataField: 'project_id',
      text: [
        checkMot('projet'),
        <Bouton
          key={'project_id_header_search'}
          type={type_btn.lupeSearch}
          cliquer={() => afficherFiltre('project_id', checkMot('projet'))}
        >
          <VscSearch size={10} />
        </Bouton>,
      ],
      sort: true,
      headerAlign: 'left',
      align: 'left',
      hidden: true,
      formatter: (cell) => {
        for (let i = 0; i < projects_list.length; i++) {
          if (projects_list[i].project_id === cell) {
            return projects_list[i].project_name;
          }
        }
        return cell;
      },
    },
    {
      dataField: 'graph_name',
      text: [checkMot('nom') + ' '],
      sort: true,
      headerAlign: 'left',
      align: 'left',
      filter: textFilter(),
      formatter: (cell, row) => {
        return (
          <span
            title={checkMot(
              Object.keys(glossaire_type_de_graphe).filter(
                (objKey) =>
                  glossaire_type_de_graphe[objKey] === row.graph_type_id
              )
            )}
          >
            {cell}
          </span>
        );
      },
    },

    {
      dataField: 'graph_type_id',
      text: checkMot('type_de_graphe') + ' ',
      sort: true,
      headerAlign: 'left',
      align: 'left',
      hidden: true,
      formatter: (cell) =>
        checkMot(
          Object.keys(glossaire_type_de_graphe).find(
            (key) => glossaire_type_de_graphe[key] === parseInt(cell)
          )
        ),
      filter: selectFilter({
        options: Object.fromEntries(
          Object.keys(glossaire_type_de_graphe)
            .map((objKey) => [
              glossaire_type_de_graphe[objKey],
              checkMot(objKey),
            ])
            .slice(1)
        ),
        placeholder: checkMot('selectionner'),
      }),
    },
  ]);

  // Effect for initial data fetch and updates
  useEffect(() => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      const listeDesProjetsId = getProjectIDTree(
        searchKeyInTree(
          { nodes: arborescence_projets },
          parseInt(project_id_url)
        )
      );
      dispatch(actions.reqRecupererListeGraphes(listeDesProjetsId));
    } else if (filtre_projects_list_id.length > 0) {
      dispatch(actions.reqRecupererListeGraphes(filtre_projects_list_id));
    }
  }, [project_id_url, filtre_projects_list_id, arborescence_projets, dispatch]);

  const afficherFiltre = (dataField, placeholder) => {
    setColumns((prevColumns) =>
      prevColumns.map((col) => {
        if (col.dataField === dataField) {
          return {
            ...col,
            filter: textFilter({ placeholder }),
          };
        }
        return col;
      })
    );
  };

  const rafraichirTableau = () => {
    if (!isNaN(project_id_url) && project_id_url !== '') {
      const listeDesProjetsId = getProjectIDTree(
        searchKeyInTree(
          { nodes: arborescence_projets },
          parseInt(project_id_url)
        )
      );
      dispatch(actions.reqRecupererListeGraphes(listeDesProjetsId));
    } else {
      dispatch(actions.reqRecupererListeGraphes(filtre_projects_list_id));
    }
  };

  // Calculate filtered graphs list
  const listeGraphesAfficher =
    listeGraphes?.reduce((acc, graphe) => {
      if (interfaceAdmin) {
        if (filtre_projects_list_id.includes(parseInt(graphe.project_id))) {
          acc.push(graphe);
        }
      } else {
        const listeDesProjetsId = getProjectIDTree(
          searchKeyInTree(
            { nodes: arborescence_projets },
            parseInt(project_id_url)
          )
        );
        if (listeDesProjetsId.includes(parseInt(graphe.project_id))) {
          acc.push(graphe);
        }
      }
      return acc;
    }, []) || [];

  if (listeGraphesAfficher.length > 0) {
    siLaListeAUneValeur(true);
  }

  return (
    <>
      <Tableau
        cleLigne={'graph_id'}
        privilegeCreer={privilege.creer_des_graphes}
        creer={creer}
        iconeCreer={iconeCreer}
        donnees={listeGraphesAfficher}
        colonnes={columns}
        selectionnerLignes={selectRow}
      >
        <AttenteRequete
          request_type={requestType.recuperation_de_la_liste_des_graphes}
          str={checkMot('maj_graphes_en_cour')}
        >
          <Bouton
            hoverText={checkMot('refresh')}
            ajoutClass={S.btn}
            type={type_btn.outil}
            rond={true}
            cliquer={rafraichirTableau}
          >
            <VscRefresh size={15} />
          </Bouton>
        </AttenteRequete>
      </Tableau>
    </>
  );
};

export default TableauGraphe;
